<div class="visibility-container">
  <div class="visibility-title">
    {{ 'TARGET-GROUP.TITLE' | translate }}
  </div>
  <div 
    class="visibility-text" 
    [innerHTML]="'TARGET-GROUP.PUBLISH-TRAINING.TEXT' | translate"
  ></div>
  <dx-tabs
    width="100%"
    [selectedIndex]="getVisibilityModeIndex()"
    [showNavButtons]="false"
    [dataSource]="visibilityModes"
    (onItemClick)="onVisibilityModeChange($event)"
    [disabled]="isViewMode"
    class="visibility-tabs-container"
  ></dx-tabs>
  <div *ngIf="visibilityMode === EventVisibilityModeModel.Subscribers">
    <app-subscriber-selector
      [isViewMode]="isViewMode"
      [subscriptionIds]="subscriptionIds"
      (subscriptionIdsChange)="subscriptionIdsChange.emit($event)"
      [subscribers]="subscribers"
    ></app-subscriber-selector>
  </div>
  <div *ngIf="visibilityMode === EventVisibilityModeModel.MyContactList">
    <div class="organization-units-container">
      <dx-drop-down-box
        [(value)]="organizationUnitIds"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.LOCATIONS-DEPARTMENTS' | translate"
        [dataSource]="organizationUnits"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            [searchEnabled]="true"
            [dataSource]="organizationUnits"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="
              onOrganizationUnitsSelected($event)
            "
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    <div class="training-groups-container">
      <dx-drop-down-box
        [(value)]="trainingGroupIds"
        [inputAttr]="{ 'aria-label': 'Owner' }"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
        [dataSource]="trainingGroups"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
        [showClearButton]="true"
        (onValueChanged)="onTrainingGroupsValueChanged($event)"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            #trainingGroupsTree
            [searchEnabled]="true"
            [dataSource]="trainingGroups"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="
              onTrainingGroupSelected($event)
            "
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    <div class="roles-container">
      <dx-drop-down-box
        [(value)]="roleIds"
        valueExpr="id"
        displayExpr="name"
        [label]="'COMMON.FIELDS.ROLES' | translate"
        [dataSource]="roles"
        [readOnly]="isViewMode"
        labelMode="floating"
        stylingMode="outlined"
        [showClearButton]="true"
        (onValueChanged)="onRolesValueChanged($event)"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-tree-view
            #rolesTree
            [searchEnabled]="true"
            [dataSource]="roles"
            dataStructure="plain"
            keyExpr="id"
            selectionMode="multiple"
            showCheckBoxesMode="normal"
            [selectNodesRecursive]="false"
            displayExpr="name"
            [selectByClick]="true"
            (onItemSelectionChanged)="onRoleSelected($event)"
          ></dx-tree-view>
        </div>
      </dx-drop-down-box>
    </div>

    @if(isVisibleToEveryone) {
      <div class="info-container visible-text-container">
        <i class="dx-icon dx-svg-icon" [innerHTML]="getClockIcon()"></i>
        <span [innerHTML]="getVisibleToEveryoneText()"></span>
      </div>
    } @else {
      <div class="info-container employee-target-container">
        <i class="dx-icon dx-svg-icon" [innerHTML]="getTargetIcon()"></i>
        <span 
          [innerHTML]="getVisibleToText()"
        ></span>
      </div>
    }
  </div>
</div>